//import { STORE_COMMIT } from "./store";
import settings from '../settings';

const util = {
	handleError(error, commit) {
		//commit(CHANGE_LOGINTOKEN, null, { root: true });
		console.log("FP: ", error);
		console.log("FP: ", commit);



		if (error && error.status == 401) {
			this.appendEventLogError(commit, "Du måste logga in. error.status header 401")
			alert("Du måste logga in");
			return;
		}

		if (error && error.status == 404) {
			this.appendEventLogError(commit, "Sidan kunde inte hittas")
			alert("Header 404, sidan skunde inte hittas");
			return;
		}

		if (error && error.status != 200) {
			this.appendEventLogError(commit, "Header fail")
			alert("Header fail: " + error.status);
			return;
		}

		if (error && error.message) {
			this.appendEventLogError(commit, "handleError: " + error.message)
			alert("Error: " + error.message)
			return;
		}

		alert("handleError: " + error)
	},
	handleResult(result, commit) {

		//commit(CHANGE_LOGINTOKEN, null, { root: true });
		console.log("FP: ", result);
		console.log("FP: ", commit);

		if (result == null) {
			this.appendEventLogError(commit, "Result is null")
			alert("Ett fel har inträffat, result är null");
			return;
		}



		// om vi kommer hit har vi 200 OK, och result och data. 
		if (result.data.status != "OK" && result.data.message == null) { // server meddelande
			const message = JSON.stringify(result.data)
			this.appendEventLogError(commit, "Server response: " + message)
			alert(message);
		}

		if (result.data.status != "OK" && result.data.message != null) { // server meddelande
			this.appendEventLogError(commit, "ServerErrorMessage: " + result.data.message)
			alert(result.data.message);
		}

		// kommer vi hit ska allting vara OK 200. 
		if (result.data.status == "OK" && result.data.message != null) { // server meddelande
			this.appendEventLogOK(commit, "ServerMessage: " + result.data.message)
		}

		if (result.data.status == "OK" && Array.isArray(result.data.messageList)) {

			result.data.messageList.forEach(message => {

				let status = message.status;

				this.appendEventLog(commit, status, "ServerMessageList: " + message.message);

			})

		}

	},
	appendEventLogOK(commit, message) {

		this.appendEventLog(commit, "OK", message);

	},
	appendEventLogInfo(commit, message) {
		this.appendEventLog(commit, "INFO", message);
	},
	appendEventLogError(commit, message, truncate) {

		if (truncate && message.length > 1000) {
			message = message.substring(0, 1000) + "..."
		}

		this.appendEventLog(commit, "ERROR", message);
		//axios.post('event/error', { message: "HandleResult Axios ERROR: " + message })
		fetch(settings.baseUrl + 'event/error', { method: "POST", body: JSON.stringify({ message: "HandleResult FETCH ERROR: " + message }) })
	},
	appendEventLogDebug(commit, message) {
		this.appendEventLog(commit, "DEBUG", message);
	},

	appendEventLog(commit, status, message) {
		const event = { status: status, message: message }

		commit("appendEventLog", event, { root: true });

		setTimeout(() => {
			commit("displayedEvent", event.id, { root: true })
		}, 1000)


	},


	handleJsonMessages(commit, json, debug, silent) {


		if (debug && json.debug != null) {

			this.appendEventLogDebug(commit, json.debug);

		}

		if (json.message != "") {
			if (json.status == "OK") {
				this.appendEventLogOK(commit, json.message);
			} else if(!silent){
				this.appendEventLogError(commit, "Error: " + json.message);
			}
		}

		// om vi har en meddelande lista 
		if (json.messageList && Array.isArray(json.messageList)) {

			json.messageList.forEach(message => {

				let status = message.status;

				this.appendEventLog(commit, status, "ServerMessageList: " + message.message);

			})
		}

		// om det inte är OK men vi inte har något meddelande
		if (json.status != "OK" && json.message == null) { // server meddelande
			const message = JSON.stringify(json)
			this.appendEventLogError(commit, "Server response: " + message)

		}

	},

	// hämtar json data och kontrollerar status OK
	getJson(commit, response, data, debug, silent = false) {

		console.log('FP: debug:', debug);
		if (data){
			//
		}
		//console.log('FP: data:', data);


		const context = this

		if (!response) {
			const message = "Resonse är null";
			this.appendEventLogError(commit, message);
			throw new Error(message);
		}

		if (response && response.status == 401) {
			const message = "Du måste logga in. (Header 401) "
			if (silent){
				this.appendEventLog(commit, message);
			}else{
				this.appendEventLogError(commit, message);
			}
			
			throw new Error(message);
		}

		if (response && response.status == 404) {
			const message = "Sidan kunde inte hittas (Header 404) "
			this.appendEventLogError(commit, message);
			throw new Error(message);
		}

		// om det är ett svar i html/text
		const contentType = response.headers.get("content-type");

		if (!contentType || !contentType.includes("application/json")) {

			this.appendEventLogError(commit, "Not a json response");

			response.text().then(function (text) {
				const message = "Server response: " + text;
				context.appendEventLogError(commit, message);
				throw new Error(message);
			});

			throw new Error("Not a json response");
			//return null;
		}

		return response.json().then(json => {

			context.handleJsonMessages(commit, json, debug, silent);

			/*if (json && json.status != "OK") {
				throw new Error("Json.status: " + json.status)
			}*/


			return json;

		}).catch(error => {

			const message = "Json failed: " + error;
			context.appendEventLogError(commit, message);
			throw new Error(message);
		})



	},

	/*

	console.log('FP: response: ', response);

				util.getJson(commit, response, data);

				if (response && response.status == 200) {

					const contentType = response.headers.get("content-type");

					if (contentType && contentType.includes("application/json")) {
						response.json().then(json => {
							console.log('FP: json: ', json);

							throw new Error("JSON TEST ERROR");

						}).catch(error => {

							alert("GOT IT", error)

							//throw error
							util.handleFetchError();


						})

						return true;
					}




				}

				if (response && response.status != 200) {

					response.text().then(function (text) {
						alert("TEXT: " + text);
					});


					if (response && response.status == 401) {
						throw new Error("Header 401");
					} else {
						throw new Error("Fetch error message, header: " + response.status);
					}

				}


				alert("DONE");
	*/

	getHeaders(loginToken, background) {

		if (loginToken == null) {
			return null
		}

		if (!background) {
			background = false
		}

		return { "logintoken": loginToken, "background": background }


	},

	getPOSTRequest(loginToken, background, data, attempt = 0) {
		var request = this.getGETRequest(loginToken, background, attempt);
		request.method = "POST";
		request.body = JSON.stringify(data)

		return request;
	},


	getGETRequest(loginToken, background, attempt = 0) {

		if (!background) {
			background = false
		}

		return {
			signal: AbortSignal.timeout(60000), headers: {
				"logintoken": loginToken, "background": background, "attempt": attempt, Authorization: "Basic Ym9vdmUtdzM6RjdZalNCdW5jN2RxMGhxekY5NitTVTk=" } }

	},

	getDELETERequest(loginToken, background) {

		var request = this.getGETRequest(loginToken, background);
		request.method = "DELETE";

		return request;

	},

	handleFetchError() {
		throw new Error("Fetch error message");
	},

	metaProduct(){
		//const now = new Date().toLocaleTimeString();

		
		return { add: null, updated: null, details: null  }
			
	},






}

export default util